module.exports = __webpack_public_path__ + "static/media/github.d779f6b8.svg";